import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { publicEventApi } from "src/app/services/constants/api.constants";
import { environment } from "../../../environments/environment";
import { HelpersService, HttpBaseService } from "@evento-ng/libs";
import { Router } from "@angular/router";
import {
  EVENT_NAME_AR,
  EVENT_NAME_EN,
} from "src/app/services/constants/general.constants";
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  cards: any[] = [];
  isMobile = false;
  constructor(
    private dataService: HttpBaseService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private router: Router,
    private helpers: HelpersService
  ) {
    if (window.screen.width < 768) this.isMobile = true;
  }

  ngOnInit(): void {
    this.spinner.show();
    this.dataService
      .get(`${publicEventApi}?creatorId=` + environment.CREATORID, {
        headers: { "Accept-Language": this.translate.currentLang },
      })
      .subscribe(
        (res) => {
          this.cards = res.data;
          this.spinner.hide();
        },
        (err) => {
          this.spinner.hide();
        }
      );
  }

  scrollToElement(element: any): void {
    this.router.navigate(["/home"], { fragment: element });
    this.router.navigateByUrl("/home");
    document.getElementById(element)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }

  scrollTo(section: any) {
    this.scrollToElement(section);
    event!.preventDefault();
  }
}
